import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

export default function PrivacyPolicy() {
  const nav = useNavigate();

  return (
    <div style={{
          padding: 16,
          maxWidth: 800,
          margin: "0 auto",
          lineHeight: 1.5,

          height: "100%",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
        }}
    >
      {/* Voltar */}
      <button
        onClick={() => nav("/config", { replace: true })}
        style={{
          background: "transparent",
          border: "none",
          color: "rgba(255,255,255,0.85)",
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: 0,
          cursor: "pointer",
          marginTop: 6,
          marginBottom: 14,
        }}
      >
        <FiArrowLeft /> Voltar
      </button>

      <h1>Política de Privacidade – FinBot</h1>
      <p>
        <strong>Última atualização:</strong> 24 de dezembro de 2025
      </p>

      <p>
        Esta Política de Privacidade descreve como o <strong>FinBot</strong> coleta,
        utiliza, armazena e protege os dados pessoais de seus usuários, em
        conformidade com a Lei Geral de Proteção de Dados (LGPD).
      </p>

      <h2>1. Controlador dos dados</h2>
      <p>
        O controlador dos dados pessoais tratados no FinBot é:
      </p>
      <p>
        <strong>NewCo Administração e Participações Ltda, CNPJ 37.785.876/0001-09</strong><br />
        Brasil<br />
        E-mail de contato:{" "}
        <a href="mailto:contato@montebrasil.com.br">
          contato@montebrasil.com.br
        </a>
      </p>

      <h2>2. Dados que coletamos</h2>
      <p>
        Coletamos apenas os dados necessários para o funcionamento do
        aplicativo, incluindo:
      </p>
      <ul>
        <li>nome e endereço de e-mail;</li>
        <li>informações de autenticação da conta;</li>
        <li>dados da carteira de ativos informados pelo usuário;</li>
        <li>registros de operações de compra e venda inseridas no app.</li>
      </ul>
      <p>
        O FinBot <strong>não executa ordens</strong>, <strong>não acessa contas bancárias</strong> e
        <strong> não realiza operações financeiras</strong> em nome do usuário.
      </p>

      <h2>3. Finalidade do tratamento</h2>
      <p>
        Os dados pessoais são utilizados exclusivamente para:
      </p>
      <ul>
        <li>identificar e autenticar o usuário;</li>
        <li>viabilizar o funcionamento do aplicativo;</li>
        <li>exibir carteira, histórico e análises;</li>
        <li>melhorar a experiência e a qualidade do serviço;</li>
        <li>prestar suporte quando solicitado.</li>
      </ul>

      <h2>4. Base legal</h2>
      <p>
        O tratamento dos dados pessoais é realizado com base:
      </p>
      <ul>
        <li>na execução do contrato entre o usuário e o FinBot;</li>
        <li>no legítimo interesse para garantir segurança, estabilidade e melhoria do serviço;</li>
        <li>no cumprimento de obrigações legais, quando aplicável.</li>
      </ul>

      <h2>5. Compartilhamento e provedores</h2>
      <p>
        O FinBot não vende nem compartilha dados pessoais para fins comerciais.
      </p>
      <p>
        Podemos utilizar provedores de infraestrutura e serviços técnicos
        (como hospedagem e armazenamento de dados), que tratam os dados
        exclusivamente para garantir o funcionamento do aplicativo, sob
        obrigações de confidencialidade e segurança.
      </p>
      <p>
        Esses provedores podem estar localizados no Brasil ou no exterior.
      </p>

      <h2>6. Armazenamento e segurança</h2>
      <p>
        Adotamos medidas técnicas e organizacionais adequadas para proteger
        os dados pessoais contra acessos não autorizados, perda, alteração
        ou divulgação indevida.
      </p>
      <p>
        Nenhum sistema é absolutamente seguro, mas buscamos continuamente
        aprimorar nossas práticas de segurança.
      </p>

      <h2>7. Retenção dos dados</h2>
      <p>
        Os dados pessoais são mantidos enquanto a conta do usuário estiver
        ativa.
      </p>
      <p>
        Após a solicitação de exclusão da conta, os dados serão excluídos ou
        anonimizados em prazo razoável, salvo quando a retenção for exigida
        por obrigação legal.
      </p>

      <h2>8. Direitos do usuário</h2>
      <p>
        Nos termos da LGPD, o usuário pode:
      </p>
      <ul>
        <li>confirmar a existência de tratamento;</li>
        <li>acessar seus dados pessoais;</li>
        <li>corrigir dados incompletos ou desatualizados;</li>
        <li>solicitar a exclusão ou anonimização dos dados;</li>
        <li>obter informações sobre o uso dos dados.</li>
      </ul>

      <h2>9. Exclusão de conta</h2>
      <p>
        O usuário pode iniciar a solicitação de exclusão da conta diretamente
        pelo aplicativo, na área de <strong>Configurações da Conta</strong>.
      </p>
      <p>
        Alternativamente, a solicitação pode ser feita pelo e-mail de contato
        informado nesta política.
      </p>

      <h2>10. Alterações nesta política</h2>
      <p>
        Esta Política de Privacidade pode ser atualizada periodicamente.
        A versão mais recente estará sempre disponível nesta página.
      </p>

      <h2>11. Contato</h2>
      <p>
        Em caso de dúvidas ou solicitações relacionadas à privacidade e
        proteção de dados, entre em contato:
      </p>
      <p>
        📧{" "}
        <a href="mailto:contato@montebrasil.com.br">
          contato@montebrasil.com.br
        </a>
      </p>
    </div>
  );
}

